export default __webpack_public_path__ + "static/media/as.dd870e87.svg";